import React, { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';
import { Spin } from 'antd';

const NpsPaddedArcs = ({ data, isLoading }) => {
  const npsTotalScore = Math.floor(
    ((data?.promoters_count ?? 0) - (data?.detractors_count ?? 0)) /
      (data?.total_replies ?? 1) *
      100
  );

  const npsAvg = Math.floor(data?.average_nps_percentage ?? 0);

  const [chartOptions, setChartOptions] = useState({
    chart: { type: 'donut' },
    plotOptions: {
      pie: { donut: { size: '60%' } },
    },
    dataLabels: { enabled: false },
    fill: { type: 'gradient' },
    legend: { position: 'bottom' },
    colors: ['#9ecf5c', '#F0af61', '#FF6e7a'],
    labels: ['Promoters', 'Passives', 'Detractors'],});

  const chartSeries = [
    data?.promoters_count ?? 0,
    data?.passives_count ?? 0,
    data?.detractors_count ?? 0,
  ];

  const isAllZero = chartSeries.every((value) => value === 0);

  useEffect(() => {
    // 🔴 Removed annotations from chartOptions
    setChartOptions((prevOptions) => ({
      ...prevOptions,
    }));
  }, [data, isAllZero, npsAvg]);

  if (isLoading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Spin />
      </div>
    );
  }

  return (
    // ✅ Chart wrapper added with position: relative
    <div style={{ position: 'relative', width: '100%', height: 350 }}>
      <ReactApexChart
        options={chartOptions}
        series={isAllZero ? [1] : chartSeries}
        type="donut"
        height={350}
      />
      {/* ✅ Custom label overlay for % value */}
      <div
        className="nps-avg-label-arc"
      >
        {isAllZero ? 'N/A' : `${npsAvg}%`}
      </div>
    </div>
  );
};

export default NpsPaddedArcs;